module.exports = __webpack_public_path__ + "img/canadian.a2c5be05.png";